import { timelineMilestones } from "@/mocks/archiveEntries";

const Timeline = () => {
  return (
    <section id="timeline" className="relative w-full overflow-hidden bg-foreground-950 py-16 md:py-24">
      <div className="pointer-events-none absolute -right-24 top-10 h-72 w-72 rounded-full bg-primary-500/20 blur-3xl" />
      <div className="pointer-events-none absolute -left-20 bottom-0 h-64 w-64 rounded-full bg-accent-500/10 blur-3xl" />

      <div className="relative mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="reveal inline-flex items-center gap-2 text-xs font-medium tracking-[0.24em] text-accent-400">
            <span className="h-px w-8 bg-accent-500" />
            留档时间线
          </span>
          <h2 className="reveal mt-5 font-heading text-2xl font-bold leading-snug text-background-50 md:text-4xl">
            留档不是一次性动作，而是一条持续更新的备份线
          </h2>
          <p className="reveal mt-4 text-sm leading-relaxed text-background-300 md:text-base">
            从档案库对外开放至今，每一次归档、校验与整编都会记录在时间线上，方便你确认某份留档在什么时间点完成备份。
          </p>
        </div>

        <div className="mt-12 md:mt-16">
          <div className="relative border-l border-background-100/15 pl-6 md:pl-10">
            {timelineMilestones.map((item, index) => (
              <div
                key={item.date}
                className={`reveal relative ${index === timelineMilestones.length - 1 ? "" : "pb-10 md:pb-12"}`}
              >
                <span className="absolute -left-[31px] top-1 flex h-5 w-5 items-center justify-center rounded-full border border-accent-500/60 bg-foreground-950 md:-left-[47px]">
                  <span className="h-2 w-2 rounded-full bg-accent-500" />
                </span>
                <div className="flex flex-col gap-1 md:flex-row md:items-baseline md:gap-6">
                  <span className="font-heading text-lg font-bold text-accent-400 md:w-24 md:shrink-0">
                    {item.date}
                  </span>
                  <div>
                    <h3 className="font-heading text-lg font-semibold text-background-50">
                      {item.title}
                    </h3>
                    <p className="mt-2 max-w-2xl text-sm leading-relaxed text-background-300">
                      {item.desc}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Timeline;